/* Fransk katalog for locale-bank-misc-no.js (del 3 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'bank.guided.tabHandling': 'À traiter · {{count}}',
  'bank.guided.tabDeviation': 'Crée un écart · {{count}}',
  'bank.guided.postsCauseDeviation': '{{count}} écritures comptabilisées créent un écart',
  'bank.guided.linkHelp': 'Associez un reçu ou une facture à l\'achat. Si la documentation n\'existe pas, choisissez « Sans justificatif » afin que le choix soit enregistré et puisse être contrôlé plus tard.',
  'bank.guided.purchasesMissing': '{{count}} achats sans justificatif.',
  'bank.guided.noneMissing': 'Aucun justificatif manquant.',
  'bank.guided.ctl.allHandled': 'Tous les paiements sont traités',
  'bank.guided.ctl.remaining': '{{count}} restants',
  'bank.guided.ctl.vouchersLinked': 'Les justificatifs requis sont associés',
  'bank.guided.ctl.missingVouchers': '{{count}} sans justificatif',
  'bank.guided.ctl.statementBalances': 'Les soldes du relevé bancaire concordent',
  'bank.guided.ctl.deviation': 'Écart {{amount}}',
  'bank.guided.ctl.ledgerBalance': 'Le solde bancaire comptabilisé concorde',
  'bank.guided.ctl.clear': 'Prêt',
  'bank.guided.finishNote': 'Lorsque vous terminez, Plumme vérifie les soldes, verrouille la période et déplace le relevé dans les archives.',
  'bank.guided.allChecked': 'Tout est vérifié et prêt.',
  'bank.guided.resolveToFinish': 'Résolvez les points ci-dessus pour pouvoir terminer.',
  'bank.guided.toast.noPending': 'Aucune proposition en attente de validation.',
  'bank.guided.superLinks': 'SuperPlumma associe',
  'bank.guided.approveSuggestions': 'Valider les propositions',
  'bank.guided.note.tapPurchase': 'Touchez un justificatif, puis l\'achat auquel vous souhaitez l\'associer.',
  'bank.guided.note.tapSuggestion': 'Touchez un justificatif, puis la proposition. Les correspondances possibles sont mises en évidence dans la liste.',
  'bank.guided.note.dragPurchase': 'Faites glisser un justificatif sur l\'achat auquel vous souhaitez l\'associer.',
  'bank.guided.note.dragSuggestion': 'Faites glisser un justificatif sur une proposition. Les correspondances possibles sont mises en évidence dans la liste.',
  'bank.guided.err.checkImportFirst': 'Vérifiez d\'abord la transition d\'import.',
  'bank.guided.toast.postingVoided': 'L\'écriture a été annulée',
  'bank.guided.archiving': 'Archivage…',
  'bank.guided.archiveNote': 'Le contrôle est verrouillé et déplacé dans les archives. Les lignes bancaires ont déjà été comptabilisées lors de leur validation.',
  'bank.archive.lockedNote': 'Le rapprochement est verrouillé. Développez une ligne pour voir le justificatif et l\'écriture. Le compte, la TVA et la description interne peuvent être corrigés sans modifier le montant bancaire.',
  'bank.archive.searchPh': 'Rechercher des écritures',
  'bank.archive.searchHelp': 'Recherchez par date, description, montant, compte ou justificatif.',
  'bank.archive.countOf': '{{shown}} écritures sur {{total}}',
  'bank.archive.handled': 'Traité',
  'bank.archive.code': 'Code {{code}}',
  'bank.archive.auditTrail': 'Piste d\'audit',
  'bank.archive.correctionsOne': '{{count}} correction',
  'bank.archive.correctionsMany': '{{count}} corrections',
  'bank.archive.noCorrections': 'Aucune correction',
  'bank.archive.internalDescription': 'Description interne',
  'bank.archive.noVoucher': 'Aucun justificatif associé',
  'bank.archive.noMatch': 'Aucune écriture ne correspond à la recherche ou aux filtres.',
  'bank.archive.err.correctFailed': 'Impossible de corriger l\'écriture.',
  'bank.importFix.err.openFirst': 'Ouvrez l\'association ou l\'écriture avant de corriger la lecture.',
  'bank.importFix.err.reasonLine': 'Indiquez brièvement pourquoi la ligne bancaire est corrigée.',
  'bank.importFix.err.amountNumber': 'Le montant doit être un nombre.',
  'bank.importFix.removeFromRecon': 'Ignorer la ligne',
  'bank.importFix.warnTitle': 'À utiliser uniquement si le PDF/CSV a été mal lu.',
  'bank.importFix.warnBody': 'Cela ne modifie ni la banque ni les justificatifs comptabilisés. Les valeurs d\'origine sont conservées dans l\'historique.',
  'bank.importFix.blocked': 'La ligne est déjà associée ou comptabilisée. Ouvrez l\'association/l\'écriture avant de corriger la lecture elle-même.',
  'bank.importFix.originalRead': 'Lecture d\'origine',
  'bank.importFix.effect': 'Effet sur le rapprochement',
  'bank.importFix.deviationNow': 'Écart actuel :',
  'bank.importFix.afterCorrection': 'Après correction :',
  'bank.importFix.stillDeviates': 'Si l\'écart persiste, vérifiez si le solde d\'ouverture/de clôture a aussi été mal lu.',
  'bank.importFix.fixLine': 'Corriger la ligne',
  'bank.importFix.removeMisread': 'Ignorer la ligne',
  'bank.ignoreLine': 'Ignorer la ligne',
  'bank.ignoreLineHelp': 'À utiliser uniquement lorsque la ligne a été mal lue et ne figure pas sur le relevé bancaire. La ligne est conservée dans l\'historique.',
  'bank.ignoreLineConfirm': 'Ignorer la ligne',
  'bank.ignoreLineReason': 'Pourquoi la ligne est-elle ignorée ?',
  'bank.ignoreLineReasonHint': 'Requis pour la piste d\'audit.',
  'bank.ignoreLineReasonPlaceholder': 'Ex. : la ligne ne figure pas sur le relevé bancaire',
  'bank.importFix.removeNote': 'La ligne reste dans l\'historique, mais compte pour 0,00 kr et est considérée comme traitée dans le rapprochement. À utiliser uniquement lorsque la ligne ne figure pas sur le relevé bancaire.',
  'bank.importFix.whyReading': 'Pourquoi la lecture est-elle corrigée ?',
  'bank.importFix.whyReadingPh': 'Ex. : l\'OCR a lu un mauvais montant / la ligne ne figure pas sur le relevé bancaire',
  'bank.importFix.err.balancesNumber': 'Les soldes d\'ouverture et de clôture doivent être des nombres.',
  'bank.importFix.err.reasonBalance': 'Indiquez brièvement pourquoi le solde est corrigé.',
  'bank.importFix.saveBalance': 'Enregistrer le solde',
  'bank.importFix.balanceWarnTitle': 'À modifier uniquement si le solde du relevé/de l\'import est erroné.',
  'bank.importFix.balanceWarnBody': 'Le solde d\'ouverture est normalement repris du dernier solde de clôture rapproché. Le solde lu à l\'origine est conservé.',
  'bank.importFix.resultPrefix': 'Avec les lignes bancaires traitées à ce jour, l\'écart de solde devient',
  'bank.importFix.whyBalance': 'Pourquoi le solde est-il corrigé ?',
  'bank.importFix.whyBalancePh': 'Ex. : le solde de clôture a été lu sur la mauvaise ligne du PDF',
  'bank.loan.intro': 'Utilisez cette option pour les souscriptions d\'emprunt, les remboursements ou les paiements pouvant être répartis entre capital, intérêts et frais. Le compte choisi provient du plan comptable actif de l\'entreprise, et l\'écriture est passée sans TVA.',
  'bank.loan.account': 'Compte d\'emprunt/de dette',
  'bank.loan.noAccount': 'Aucun compte d\'emprunt/de dette ordinaire n\'a été trouvé dans le plan comptable actif. Créez le compte approprié ou utilisez une écriture libre.',
  'bank.loan.principal': 'Remboursement du capital / montant de l\'emprunt',
  'bank.loan.splitMismatch': 'La répartition doit correspondre au montant bancaire. Reste : {{amount}} kr.',
  'bank.loan.docLinked': 'La documentation est associée.',
  'bank.loan.docRemember': 'N\'oubliez pas la documentation.',
  'bank.loan.docHelp': 'Téléversez le contrat de prêt, le tableau d\'amortissement ou un autre justificatif. La répartition doit pouvoir être documentée.',
  'bank.loan.complex': 'La ligne concerne-t-elle une partie liée, un compte inhabituel ou un emprunt plus complexe ?',
  'bank.loan.useFree': 'Utiliser une écriture libre',
  'bank.group.err.sameDirection': 'Toutes les lignes bancaires d\'un groupe de répartition doivent avoir le même sens.',
  'bank.group.err.pickBoth': 'Sélectionnez les deux lignes bancaires du virement.',
  'bank.group.toast.transferApproved': 'Le virement a été approuvé et comptabilisé en une seule fois.',
  'bank.group.toast.allocationApproved': 'La répartition a été approuvée et comptabilisée en une seule fois.',
  'bank.group.err.approveFailed': 'Impossible d\'approuver le groupe de rapprochement.',
  'bank.group.title': 'Rapprocher plusieurs opérations bancaires',
  'bank.group.approve': 'Approuver et comptabiliser le groupe',
  'bank.group.oneOperation': 'Une opération contrôlée',
  'bank.group.oneOperationHelp': 'Le groupe réserve toutes les lignes bancaires sélectionnées. La comptabilisation et le lettrage se font ensemble côté serveur lorsque vous approuvez.',
  'bank.group.matchType': 'Type de rapprochement',
  'bank.group.typeAllocation': 'Répartir le paiement sur les postes ouverts',
  'bank.group.typeTransfer': 'Virement interne entre vos propres comptes',
  'bank.group.sourceLine': 'Ligne d\'un compte',
  'bank.group.counterLine': 'Contrepartie sur votre propre compte',
  'bank.group.pickOpposite': 'Sélectionnez la ligne bancaire opposée',
  'bank.group.transferRules': 'Seules les lignes de même date et montant, de signe opposé et sur un autre compte bancaire configuré sont proposées. Des dates différentes nécessitent un compte de transit.',
  'bank.group.noOpenItems': 'Aucun(e) {{kind}} ouvert(e) ne peut être réparti(e).',
  'bank.group.customerInvoices': 'factures clients',
  'bank.group.supplierInvoices': 'factures fournisseurs',
  'bank.group.itemRest': '{{number}} · {{party}} · reste {{amount}}',
  'bank.group.removeRow': 'Supprimer la ligne',
  'bank.corr.err.reasonVoid': 'Indiquez brièvement pourquoi l\'écriture est annulée.',
  'bank.corr.err.notFieldCorrectable': 'Ce type d\'écriture ne peut pas être corrigé champ par champ depuis le rapprochement bancaire. Annulez l\'écriture et comptabilisez-la correctement à nouveau, ou ouvrez le justificatif dans le journal des justificatifs.',
  'bank.corr.err.supplierPaymentVoid': 'Les paiements de factures fournisseurs s\'annulent depuis le justificatif fournisseur.',
  'bank.corr.err.noSupportedAction': 'Aucune action prise en charge n\'a été trouvée pour cette écriture comptabilisée.',
  'bank.receipt.toast.trashed': 'Le justificatif a été déplacé dans la corbeille.',
  'bank.receipt.err.deleteFailed': 'Impossible de supprimer le justificatif.',
  'bank.receipt.deleting': 'Suppression…',
  'bank.receipt.delete': 'Supprimer le justificatif',
  'bank.mode.toFull': 'Passer à la vue complète',
  'bank.mode.toGuided': 'Passer au mode pas à pas',
  'bank.import.toast.privateSaved': 'Relevé privé enregistré - prêt pour la revue',
  'bank.import.toast.saved': 'Relevé bancaire enregistré - prêt pour le rapprochement',
  'bank.inbox.view.statement': 'Ce relevé',
  'bank.inbox.view.unlinked': 'Non liés uniquement',
  'bank.inbox.view.all': 'Tous les justificatifs',
  'bank.inbox.showInList': 'Afficher dans la boîte de réception',
  'bank.inbox.viewing': 'Affichage : {{view}} · {{hidden}} masqué(s)',
  'bank.inbox.waiting': 'Justificatifs en attente de traitement : {{count}}',
  'bank.inbox.hide': 'Masquer la boîte de réception',
  'bank.inbox.companyAddress': 'la boîte de réception des justificatifs de l\'entreprise',
  'bank.inbox.defaultNote': 'Faites glisser un justificatif sur une ligne bancaire, ou laissez SuperPlumma proposer des correspondances.',
  'bank.inbox.uploadVoucher': 'Importer un justificatif',
  'bank.inbox.orDrag': 'Ou faites glisser · déposez sur une ligne sans justificatif',
  'bank.inbox.dropHint': 'Déposez des fichiers ici pour importer de nouveaux justificatifs.',
  'bank.inbox.noMatch': 'Aucun justificatif ne correspond à la recherche.',
  'bank.inbox.noneInSelection': 'Aucun justificatif dans cette sélection · {{hidden}} masqué(s) par le filtre',
  'bank.inbox.allDone': 'Tous les justificatifs ont été traités',
  'bank.inbox.empty': 'La boîte de réception est vide',
  'bank.inbox.tip.showAll': 'Cliquez pour afficher à nouveau toutes les lignes bancaires',
  'bank.inbox.tip.showLine': 'Cliquez pour afficher la ligne bancaire liée à ce justificatif',
  'bank.inbox.tip.linkedElsewhere': 'Lié en dehors de ce relevé bancaire',
  'bank.inbox.linkedHere': 'Lié · {{label}}',
  'bank.inbox.linkedIn': 'Lié dans {{label}}',
  'bank.inbox.previewName': 'Aperçu de {{name}}',
  'bank.inbox.voucherLower': 'justificatif',
  'bank.inbox.filteredOne': 'Filtré sur un justificatif',
  'bank.inbox.filteredN': 'Filtré sur {{count}} justificatifs',
  'bank.inbox.filterShowsLinked': 'Affiche uniquement les lignes bancaires liées aux justificatifs',
  'bank.inbox.showAllLines': 'Afficher toutes les lignes',
  'bank.inbox.nBankLines': '{{count}} lignes bancaires',
  'bank.inbox.bankLineLower': 'ligne bancaire',
  'bank.inbox.anotherStatement': 'un autre relevé bancaire',
  'bank.inbox.toast.linkedElsewhere': 'Le justificatif est lié à une ligne bancaire dans {{label}}.',
  'bank.resolve.annulText': 'L\'écriture est en double. Contre-passez-la pour qu\'elle ne soit pas prise en compte. Un éventuel justificatif est automatiquement replacé dans la boîte de réception.',
  'bank.resolve.correctText': 'L\'écriture doit exister, mais le compte, la TVA ou la description interne est erroné. Le montant bancaire et la date restent verrouillés.',
  'bank.resolve.err.voidFailed': 'Impossible d\'annuler l\'écriture comptabilisée.',
  'bank.resolve.voiding': 'Annulation…',
  'bank.resolve.confirmVoid': 'Confirmer l\'annulation',
  'bank.resolve.voidReason': 'Motif de l\'annulation',
  'bank.resolve.voidReasonHint': 'Obligatoire. Le motif est enregistré dans la piste d\'audit.',
  'bank.resolve.voidReasonPh': 'Décrivez brièvement pourquoi l\'écriture doit être annulée',
  'bank.resolve.row.postedEntry': 'Écriture comptabilisée',
  'bank.resolve.row.account': 'Compte',
  'bank.resolve.row.vat': 'TVA',
  'bank.resolve.row.amount': 'Montant',
  'bank.resolve.row.lineDate': 'Date de la ligne bancaire',
  'bank.resolve.row.bankLine': 'Ligne bancaire',
  'bank.resolve.row.voucher': 'Justificatif',
  'bank.resolve.row.notLinked': 'Non lié',
  'bank.resolve.reopenAsDeviation': 'Ouvrir comme écart',
  'bank.resolve.releaseInvestmentMatch': 'Libérer le lien bancaire',
  'bank.resolve.reverse': 'Contre-passer',
  'bank.resolve.alreadyPosted': 'Cette ligne bancaire est déjà comptabilisée ou rapprochée. Elle ne peut donc pas être traitée comme une nouvelle ligne.',
  'bank.resolve.useCorrection': 'Utilisez la correction pour le compte, la TVA ou la description interne. Le montant bancaire, la date et le lien restent verrouillés.',
  'bank.resolve.reverseInfo': 'La contre-passation annule l\'achat avec traçabilité et rouvre la ligne bancaire pour un nouveau contrôle.',
  'bank.resolve.existingInfo': 'Ceci est lié à un justificatif ou une écriture existant(e). Corrigez le justificatif lui-même si la base est erronée.',
  'bank.resolve.verifiableInfo': 'Ce lien peut être vérifié depuis le détail de l\'écriture.',
  'bank.resolve.approving': 'Approbation…',
  'bank.resolve.approveN': 'Approuver {{count}} propositions',
  'bank.resolve.confirmIntro': 'Vérifiez le récapitulatif. Les propositions rapprochées d\'une écriture existante ne créent pas de nouvelle comptabilisation.',
  'bank.resolve.voucherReturns': 'Le justificatif « {{name}} » est automatiquement replacé dans la boîte de réception lorsque l\'écriture est annulée.',
  'bank.err.uploadVoucherFailed': 'Impossible d\'importer le justificatif.',
  'bank.drop.attachAsDoc': 'Joint comme pièce justificative',
  'bank.drop.uploadAnalyzeLink': 'Importé, analysé et lié',
  'bank.receipt.confirmDelete': 'Supprimer le justificatif de la boîte de réception ? Il est déplacé dans la corbeille et peut être restauré.',
  'bank.percentDone': '{{pct}} % terminé',
  'mypage.role.owner': 'Propriétaire',
  'mypage.role.admin': 'Administrateur',
  'mypage.role.accountant': 'Comptable',
  'mypage.role.viewer': 'Lecteur',
  'mypage.shortcut.oversikt.title': 'Vue d\'ensemble',
  'mypage.shortcut.oversikt.text': 'Score de santé et vue d\'ensemble financière du foyer',
  'mypage.shortcut.forbruk.title': 'Dépenses',
  'mypage.shortcut.forbruk.text': 'Où va l\'argent, réparti par catégorie',
  'mypage.shortcut.familie.title': 'Famille',
  'mypage.shortcut.familie.text': 'Budget commun et répartition au sein du foyer',
  'mypage.shortcut.fremtid.title': 'Avenir',
  'mypage.shortcut.fremtid.text': 'Épargne, prêts, retraite et projets d\'avenir',
  'mypage.shortcut.skatt.title': 'Impôts',
  'mypage.shortcut.skatt.text': 'skattemelding personnelle, déductions et estimation',
  'mypage.fallback.business': 'Entreprise',
  'mypage.fallback.signedInUser': 'Utilisateur connecté',
  'mypage.fallback.employerLoadError': 'Impossible de charger les employeurs.',
  'mypage.verify.body': 'Certaines fonctionnalités, notamment les invitations de clients et le portail salarié, nécessitent que {{email}} soit confirmée. Renvoyez le lien si vous ne le trouvez pas, ouvrez le lien dans l\'e-mail, puis indiquez que vous avez confirmé.',
  'mypage.verify.resend': 'Renvoyer la confirmation',
  'mypage.verify.sending': 'Envoi...',
  'mypage.verify.confirmed': 'J\'ai confirmé',
  'mypage.verify.checking': 'Vérification...',
  'mypage.err.profileNotConnected': 'L\'enregistrement du profil n\'est pas connecté au serveur.',
  'mypage.toast.profileUpdated': 'Le profil a été mis à jour',
  'mypage.err.profileUpdateFailed': 'Impossible de mettre à jour le profil.',
  'mypage.err.verifyNotConnected': 'La confirmation d\'e-mail n\'est pas connectée au serveur.',
  'mypage.toast.alreadyVerified': 'L\'adresse e-mail est déjà confirmée.',
  'mypage.toast.verifyResent': 'Le lien de confirmation a été renvoyé.',
  'mypage.err.verifySendFailed': 'Impossible d\'envoyer le lien de confirmation.',
  'mypage.err.verifyStatusFailed': 'Impossible de vérifier le statut de l\'e-mail.',
  'mypage.toast.emailVerified': 'L\'adresse e-mail est confirmée.',
  'mypage.toast.stillUnverified': 'L\'adresse n\'est toujours pas confirmée. Consultez votre boîte de réception et réessayez.',
  'mypage.err.personalNotConnected': 'Les finances personnelles ne sont pas connectées au serveur dans cette version.',
  'mypage.toast.personalCreated': 'Les finances personnelles ont été créées',
  'mypage.err.personalCreateFailed': 'Impossible de créer les finances personnelles.',
  'mypage.toast.openPersonalForFamily': 'Ouvrez Finances personnelles pour modifier Famille.',
  'mypage.toast.familyEnabled': 'Famille est activé.',
  'mypage.toast.familyDisabled': 'Famille est désactivé.',
  'mypage.err.familySaveFailed': 'Impossible d\'enregistrer le paramètre Famille.',
  'mypage.titleHelp': 'Mon espace est votre compte personnel dans Plumme – distinct des comptabilités elles-mêmes. Vous y voyez votre profil, les entreprises auxquelles vous avez accès, les employeurs chez qui vous travaillez et l\'accès à vos finances personnelles.',
  'mypage.field.memberSince': 'Membre depuis',
  'mypage.toast.onboardingNotLoaded': 'L\'intégration n\'est pas encore chargée.',
  'mypage.orgNumber': 'Org. {{orgnr}}',
  'mypage.biz.loadingTitle': 'Chargement des entreprises',
  'mypage.biz.loadingText': 'Connexion au serveur Plumme.',
  'mypage.biz.emptyTitle': 'Aucune entreprise propre',
  'mypage.biz.emptyText': 'Vous pourrez créer une entreprise ici plus tard, même si vous utilisez Plumme uniquement en tant que comptable ou particulier.',
  'mypage.clients.title': 'Missions clients',
  'mypage.clients.help': 'Entreprises auxquelles vous êtes invité en tant que comptable, administrateur ou lecteur. Les données clients sont séparées de vos propres entreprises et de Finances personnelles.',
  'mypage.clients.setup': 'Configuration comptable',
  'mypage.clients.access': 'Accès clients',
  'mypage.clients.empty': 'Vous n\'avez aucune mission client active. Les invitations s\'affichent globalement après la connexion.',
  'mypage.pf.creating': 'Création...',
  'mypage.pf.create': 'Créer les finances personnelles',
  'mypage.pf.intro': 'Votre conseiller personnel pour les finances du foyer - séparé de la comptabilité des entreprises. Choisissez une vue pour commencer.',
  'mypage.pf.family': 'Famille',
  'mypage.pf.familyText': 'Afficher la page Famille dans Finances personnelles.',
  'mypage.pf.emptyIntro': 'Créez un client Finances personnelles pour regrouper vue d\'ensemble privée, import, foyer, impôts et rapports sans les mélanger avec les clients comptables.',
  'mypage.emp.fallbackRole': 'Salarié',
  'mypage.emp.loadingTitle': 'Chargement des employeurs',
  'mypage.emp.emptyTitle': 'Aucun employeur',
  'mypage.emp.loadingText': 'Connexion au portail salarié.',
  'mypage.emp.emptyText': 'Aucun accès au portail salarié n\'est enregistré pour cet utilisateur.',
  'mypage.err.passwordResetNotConnected': 'La réinitialisation du mot de passe n\'est pas connectée au serveur.',
  'mypage.toast.passwordLinkSent': 'Un lien pour modifier le mot de passe a été envoyé par e-mail',
  'mypage.err.passwordLinkFailed': 'Impossible d\'envoyer le lien de mot de passe.',
  'mypage.saving': 'Enregistrement...',
  'mypage.hh.loadError': 'Impossible de charger le lien du foyer.',
  'mypage.hh.updateError': 'Impossible de mettre à jour le foyer.',
  'mypage.hh.inviteEmailFailed': 'L\'invitation a été créée, mais l\'e-mail n\'a pas pu être envoyé. Vous pouvez réessayer.',
  'mypage.hh.inviteSent': 'L\'invitation a été créée et envoyée.',
  'mypage.hh.left': 'Le lien du foyer a pris fin.',
  'mypage.hh.hiddenPending': 'L\'invitation a été retirée et supprimée de la liste.',
  'mypage.hh.hidden': 'L\'invitation a été supprimée de la liste.',
  'mypage.hh.loading': 'Chargement du statut du foyer …',
  'mypage.hh.partnerFallback': 'Partenaire connecté',
  'mypage.hh.twoAccounts': 'Deux comptes distincts · page Famille partagée',
  'mypage.hh.leaveConfirm': 'Déconnecter le foyer ? Chacun conserve ses propres données, tandis que le profil Famille partagé prend fin.',
  'mypage.hh.leaving': 'Déconnexion …',
  'mypage.hh.leave': 'Déconnecter le foyer',
  'mypage.hh.inviteIntro': 'Invitez un partenaire par e-mail. Le destinataire peut se connecter ou créer un nouveau compte Plumme, et sera aidé à créer Finances personnelles avant que le lien ne soit approuvé.',
  'mypage.hh.inviting': 'Création …',
  'mypage.hh.invite': 'Inviter un partenaire',
  'mypage.hh.userFallback': 'Utilisateur Plumme',
  'mypage.hh.joined': 'Le foyer a été relié.',
  'mypage.hh.sentInvites': 'Invitations envoyées',
  'mypage.hh.resendFailedToast': 'L\'invitation est active, mais l\'e-mail n\'a pas pu être envoyé.',
  'mypage.hh.resentToast': 'L\'invitation a été renvoyée.',
  'mypage.hh.resend': 'Renvoyer',
  'mypage.hh.remind': 'Rappeler',
  'mypage.hh.withdrawn': 'L\'invitation a été retirée.',
  'mypage.hh.removeFromList': 'Supprimer de la liste',
  'mypage.hh.status.pending': 'En attente de réponse · {{delivery}}',
  'mypage.hh.status.expired': 'Expirée',
  'mypage.hh.status.declined': 'Refusée',
  'mypage.hh.status.canceled': 'Retirée',
  'mypage.hh.status.accepted': 'Acceptée',
  'mypage.hh.delivery.delivered': 'e-mail remis',
  'mypage.hh.delivery.opened': 'e-mail ouvert',
  'mypage.hh.delivery.clicked': 'lien ouvert',
  'mypage.hh.delivery.failed': 'échec de l\'e-mail',
  'mypage.hh.delivery.bounced': 'e-mail rejeté',
  'mypage.hh.delivery.complained': 'signalé comme spam',
  'mypage.hh.delivery.delivery_delayed': 'e-mail retardé',
  'mypage.hh.delivery.sent': 'e-mail envoyé',
  'audit.domain.settings': 'Paramètres',
  'audit.domain.invoices': 'Factures',
  'audit.domain.sales': 'Ventes',
  'audit.domain.expenses': 'Achats',
  'audit.domain.customers': 'Clients',
  'audit.domain.products': 'Produits',
  'audit.domain.suppliers': 'Fournisseurs',
  'audit.domain.inbox': 'Boîte de réception',
  'audit.domain.bank': 'Banque',
  'audit.domain.mileage': 'Journal de bord kilométrique',
  'audit.domain.payroll': 'Paie',
  'audit.domain.business': 'Entreprise',
  'audit.domain.access': 'Accès',
  'audit.summary.rows': '{{count}} lignes',
  'audit.summary.fields': '{{count}} champs',
  'audit.event.updated': 'A mis à jour {{domains}}',
  'audit.event.updatedBusinessData': 'A mis à jour les données de l\'entreprise',
  'audit.event.businessCreated': 'A créé l\'entreprise',
  'audit.event.inviteCreated': 'A invité {{email}} en tant que {{role}}',
  'audit.event.inviteAccepted': '{{user}} a accepté l\'invitation',
  'audit.event.deletionRequestedFor': 'A demandé la suppression de l\'entreprise le {{date}}',
  'audit.event.deletionRequested': 'A demandé la suppression de l\'entreprise',
  'audit.event.deletionCanceled': 'A annulé la suppression de l\'entreprise',
  'audit.fallback.newUser': 'nouvel utilisateur',
  'audit.fallback.userLower': 'utilisateur',
  'audit.fallback.user': 'Utilisateur',
  'audit.fallback.unknownUser': 'Utilisateur inconnu',
  'audit.err.loadFailed': 'Impossible de charger le journal d\'activité.',
  'audit.meta.time': 'Horodatage',
  'audit.meta.user': 'Utilisateur',
  'audit.meta.role': 'Rôle',
  'audit.meta.action': 'Action',
  'audit.meta.source': 'Source',
  'audit.meta.invite': 'Invitation',
  'audit.meta.targetUser': 'Utilisateur cible',
  'audit.detail.before': 'Avant :',
  'audit.detail.after': 'Après :',
  'audit.titleHelp': 'Le journal d\'activité est une piste d\'audit : il montre toutes les actions importantes effectuées dans la comptabilité - qui a fait quoi, quand et dans quel domaine. Utile pour la traçabilité et le contrôle lorsque plusieurs personnes collaborent.',
  'audit.search': 'Rechercher dans le journal d\'activité de {{year}}',
  'audit.scope.all': 'Tous',
  'audit.scope.others': 'Autres',
  'audit.scope.mine': 'Moi',
  'audit.scope.access': 'Accès',
  'audit.col.event': 'Événement',
  'audit.empty.loadingTitle': 'Chargement du journal d\'activité',
  'audit.empty.loadingText': 'Connexion au serveur Plumme.',
  'audit.empty.noMatchTitle': 'Aucun résultat',
  'audit.empty.noMatchText': 'Aucune activité ne correspond au filtre. Essayez de le réinitialiser.',
});
